import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { useChatContext } from 'features/chat/context/chat';
import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

import { showErrorToast } from 'shared/components/Toast';

export const useChatMessagesReadAllMutation = () => {
  const {
    lastReadMessageId,
    setUnreadMessagesCount,
    unreadMessagesCount,
    resetLastReadMessageId,
  } = useChatContext();
  const { chatId } = useChatInterlocutorContext();
  const queryClient = useQueryClient();
  const { request } = useMutationHTTPRequest();

  return useMutation(
    () =>
      request({
        url: `/api/chats/${chatId}/messages/mark-all-as-read`,
        body: { lastReadMessageId },
      }),
    {
      onMutate: async () => {
        const previousChat = queryClient.getQueryData([
          queryKeys.chats,
          chatId,
        ]);

        resetLastReadMessageId();
        setUnreadMessagesCount(-unreadMessagesCount);

        return { previousChat };
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [queryKeys.chats, chatId],
        });
      },
      onError: (err, _, context) => {
        queryClient.setQueryData(
          [queryKeys.chats, chatId],
          context?.previousChat
        );

        showErrorToast(
          "There's an error with reading messages. Please try again later."
        );

        logError(err);
      },
    }
  );
};
